import JourneyAnalytics from '../../journey-analytics/page'
import UsageMetrics from '../../usage-metrics/page'

import { OrganizationReport } from './organization-tabs'

import { Segmented } from '@/components/activity/activity-panel'

type ReportsTabProps = {
  orgId: string
  report: OrganizationReport
  onReportChange: (report: OrganizationReport) => void
}

/** both reports are Power BI embeds filtered to this organization */
export const ReportsTab = ({
  orgId,
  report,
  onReportChange
}: ReportsTabProps) => (
  <div className="space-y-4">
    <div className="flex flex-wrap items-center gap-3">
      <Segmented
        ariaLabel="Report"
        onChange={onReportChange}
        options={[
          { value: 'usage', label: 'Usage' },
          { value: 'journeys', label: 'Journey analytics' }
        ]}
        value={report}
      />
      <span className="text-xs text-muted-foreground">
        Filtered to organization <span className="font-mono">{orgId}</span>
      </span>
    </div>
    {report === 'usage' ? (
      <UsageMetrics orgId={orgId} />
    ) : (
      <JourneyAnalytics orgId={orgId} />
    )}
  </div>
)
